// @flow

import type {ApplicationState} from '../../types'
import {createSelector} from 'reselect'

import {getSelectedCity} from './getSelectedCity'
import {getDistricts} from './getDistricts'

export function getDistrictsByCity(appState: ApplicationState): District[] {
  return _getDistrictsByCity(appState.map) 
}

const _getDistrictsByCity = createSelector(
  [getSelectedCity.internal, getDistricts.internal],
  (city, districts) => {
    if (!city) return []
    const filtered = districts.filter(d => d._links.city === city)
            .sort((d1, d2) => {
              if (d1.name < d2.name) return -1
              if (d1.name > d2.name) return 1
              return 0
            })
    filtered.unshift({
      name: 'ไม่ระบุ',
      name_en: 'unknown',
      _links: {
        self: null,
      }
    }) 
    return filtered
  }
)

getDistrictsByCity.internal = _getDistrictsByCity
